<template>
  <div>
    <v-app-bar
      color="#0D3B60"
      dark
      dense
    >
      <v-app-bar-nav-icon
				@click="() => drawer = !drawer"
				class="d-block d-sm-block d-md-none"
			></v-app-bar-nav-icon>

      <v-spacer></v-spacer>
    </v-app-bar>

    <div class="row d-none d-sm-none d-md-block">
      <div class="col d-none d-sm-block">
        <div class="navbar">
          <div class="row">
            <div class="col">
              <img class="logo" src="../../assets/logo.png" alt="">
            </div>
            <div class="col d-flex align-center justify-center">
              <center>
                <a href="/nuestra-historia" class="items-menu mr-5">Nuestra Historia</a>
                <a href="/" link class="items-menu">
                  Comprar
                </a>
              </center>
            </div>
            <div class="col d-flex justify-content-end align-center">
            <!--<v-btn
                rounded
                text
              >
                <i class="material-icons-outlined">person</i>
              </v-btn>-->
              <v-btn
                rounded
                text
                href="/"
              >
                <i class="material-icons-outlined">shopping_bag</i>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-navigation-drawer v-model="drawer" temporary fixed>
			<v-list nav dense>
				<v-list-item two-line :class="miniVariant && 'px-0'">
					<v-list-item-content>
						<img class="logo" src="../../assets/logo.png" alt="">
					</v-list-item-content>
				</v-list-item>

				<v-divider></v-divider>

				<v-list-item-group
					v-model="group"
					active-class="deep-purple--text text--accent-4"
				>
					<v-list-item>
						<v-list-item-icon>
							<i class="material-icons-outlined">house</i>
						</v-list-item-icon>
						<v-list-item-title>Inicio</v-list-item-title>
					</v-list-item>

					<v-list-item>
						<v-list-item-icon>
							<i class="material-icons-outlined">add_shopping_cart</i>
						</v-list-item-icon>
						<v-list-item-title>Comprar</v-list-item-title>
					</v-list-item>

          <v-list-item>
						<v-list-item-icon>
							<i class="material-icons-outlined">person</i>
						</v-list-item-icon>
						<v-list-item-title>Mi cuenta</v-list-item-title>
					</v-list-item>

          <v-list-item>
						<v-list-item-icon>
							<i class="material-icons-outlined">shopping_bag</i>
						</v-list-item-icon>
						<v-list-item-title>Tienda</v-list-item-title>
					</v-list-item>


				</v-list-item-group>
			</v-list>
		</v-navigation-drawer>

  </div>
</template>

<script>
export default {
  data: () => ({
    drawer: false,
    group: '',
		miniVariant: false
  })
}
</script>

<style scoped>
.fa {
  font-size: 15px;
  margin-left: 10px
}
.logo {
  width: 140px
}
.material-icons-outlined {
  color: #0D3B60 !important
}
.navbar {
  width: 95%;
  margin: auto;
  height: 8em
}
.container-text-init {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Baloo Regular';
  font-weight: 600;
}
.container-menu {
  width: 100%;
}
.items-menu {
  width: 80px;
  color: #0D3B60;
  font-size: 20px;
  text-decoration: none;
  padding: 5px;
  font-family: 'Baloo Regular'
}
.items-menu:hover {
  text-decoration: underline
}
.v-list-item__title {
  font-family: 'Baloo Regular' !important;
}
</style>
